// authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { postWithoutTokenAPI } from '../util/Api';

export const loginUser = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await postWithoutTokenAPI('/admin/login', credentials);
      
      console.log('Login API Response:', response); // Debug log
      
      if (response.error) {
        return rejectWithValue(response.message || 'Login failed');
      }
      
      if (response.statusCode === 200 && response.message === "Login successful") {
        return {
          token: response.data.token,
          user: response.data.admin, // Note: your API returns 'admin' not 'user'
          userId: response.data.admin._id // Extract the _id explicitly
        };
      } else {
        return rejectWithValue(response.message || 'Invalid credentials');
      }
    } catch (error) {
      console.error('Login error:', error);
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

const initialState = {
  isAuthenticated: false,
  user: null,
  userId: null, // Add userId to store
  token: null,
  loading: false,
  error: null,
  sessionChecked: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.userId = null; // Clear userId on logout
      state.token = null;
      state.loading = false;
      state.error = null;
      
      localStorage.removeItem('matrimony_token');
      localStorage.removeItem('matrimony_user');
      localStorage.removeItem('matrimony_userId'); // Remove userId from localStorage
    },
    clearError: (state) => {
      state.error = null;
    },
    restoreSession: (state) => {
      const token = localStorage.getItem('matrimony_token');
      const user = localStorage.getItem('matrimony_user');
      const userId = localStorage.getItem('matrimony_userId');
      
      if (token && user) {
        state.isAuthenticated = true;
        state.token = token;
        state.user = JSON.parse(user);
        state.userId = userId; // Restore userId
      }
      state.sessionChecked = true;
      state.loading = false;
    },
    sessionCheckComplete: (state) => {
      state.sessionChecked = true;
      state.loading = false;
    },
    // Add a reducer to update user profile if needed
    updateUserProfile: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
        localStorage.setItem('matrimony_user', JSON.stringify(state.user));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        console.log('Login fulfilled:', action.payload); // Debug log
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user; // This should be the admin object
        state.userId = action.payload.userId; // Store the userId
        state.token = action.payload.token;
        state.error = null;
        
        // Store in localStorage
        localStorage.setItem('matrimony_token', action.payload.token);
        localStorage.setItem('matrimony_user', JSON.stringify(action.payload.user));
        localStorage.setItem('matrimony_userId', action.payload.userId); // Store userId separately
      })
      .addCase(loginUser.rejected, (state, action) => {
        console.log('Login rejected:', action.payload); // Debug log
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
        state.user = null;
        state.userId = null;
        state.token = null;
      });
  },
});

export const { logout, clearError, restoreSession, sessionCheckComplete, updateUserProfile } = authSlice.actions;
export default authSlice.reducer;